import React from "react";

const V = "2026-10-21";

export const BrandLogo = ({ className = "h-9", testid = "brand-logo" }: { className?: string; testid?: string }) => (
  <picture>
    <source srcSet={`/brand/iqw-logo.webp?v=${V}`} type="image/webp" />
    <img src={`/brand/iqw-logo.png?v=${V}`} alt="Instant Quote Wizard" width={900} height={408} className={`${className} w-auto max-w-full object-contain select-none`} draggable={false} data-testid={testid} />
  </picture>
);
